var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("taskList.bizNo"),
                                        prop: "bizNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition["bizNo"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "bizNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "queryCondition['bizNo']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("taskList.taskFlow"),
                                        prop: "taskTypes",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          multiple: "",
                                          clearable: true,
                                          options: {
                                            STORE_FEEDBACK: "质量反馈",
                                            PROBLEM_REPORT_HANDLE:
                                              "问题报告处理",
                                          },
                                        },
                                        model: {
                                          value: _vm.queryCondition.taskTypes,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "taskTypes",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.taskTypes",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "创建日期(从)",
                                        prop: "dateFrom",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "date",
                                          placeholder: "选择日期",
                                          "value-format": "yyyy-MM-dd",
                                        },
                                        model: {
                                          value: _vm.queryCondition.dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "创建日期(至)",
                                        prop: "dateTo",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          "value-format": "yyyy-MM-dd",
                                          type: "date",
                                          placeholder: _vm.$t("common.selDate"),
                                        },
                                        model: {
                                          value: _vm.queryCondition.dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "taskList.eightBitCodeName"
                                                ),
                                                prop: "eightBitCodeName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .eightBitCodeName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "eightBitCodeName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.eightBitCodeName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        justify: "center",
                        type: "flex",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.resetForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                border: "",
                "max-height": "540",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "taskName",
                  label: _vm.$t("apply.applyType"),
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "bizNo",
                  label: _vm.$t("taskList.bizNo"),
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "plantName",
                  label: _vm.$t("base.plant.plantName"),
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "problemLevel",
                  label: _vm.$t("storeFeedback.problemLevel"),
                  "min-width": "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "isRepeat",
                  label: _vm.$t("storeFeedback.isRepeat"),
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("ic")(scope.row.isRepeat, "COMMON", "YES_NO")
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "materialName",
                  label: _vm.$t("taskList.eightBitCodeName"),
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "taskTypeName",
                  label: _vm.$t("taskList.taskFlow"),
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "createDate",
                  label: _vm.$t("common.TaskCreationTime"),
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("dateFormatFilter")(
                              scope.row.createDate,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: _vm.$t("common.operation"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.audit(
                                  scope.row.taskType,
                                  scope.row.bizId,
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("taskList.audit")))]
                        ),
                        scope.row.taskType === "PROBLEM_REPORT_HANDLE" &&
                        scope.row.taskName === "MCD处理" &&
                        scope.row.transferAuditor != _vm.userId
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.transfer(scope.row)
                                  },
                                },
                              },
                              [_vm._v("转移")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 15, 50, 100],
                  "page-size": _vm.queryCondition.pageSize,
                  "current-page": _vm.queryCondition.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: { title: "审核", visible: _vm.auditDialog, width: "1200px" },
          on: { close: _vm.closeAuditDialog },
        },
        [_c("router-view")],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: { title: "选择人员", visible: _vm.userDialog, width: "70%" },
          on: { close: _vm.closeUserDialog },
        },
        [
          _c("userDialog", {
            ref: "userDialog",
            attrs: { paramInfo: _vm.paramInfo },
            on: { closeUserDialog: _vm.closeUserDialog },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }